module Factive.Game
{
	"use strict"
	import DependenciesContainer = Factive.Core.DependenciesContainer;

	export class AnalyticsHelper
	{
		private _eb:Factive.Core.EventBus;
		private _analyticsManager:Arkadium.Core.AnalyticsManager;
		private _dc:DependenciesContainer;

		constructor(dc:DependenciesContainer)
		{
			this._dc = dc;

			this._analyticsManager = this._dc.get("AnalyticsManager");
			this._eb = this._dc.get("EventBus");

			this._eb.add(AnalyticsConstants.ACTION_START, AnalyticsConstants.TOPIC_ANALYTIC, this.handleStart, this);
			this._eb.add(AnalyticsConstants.ACTION_SUBMIT, AnalyticsConstants.TOPIC_ANALYTIC, this.handleSubmit, this);
			this._eb.add(AnalyticsConstants.ACTION_QUIT, AnalyticsConstants.TOPIC_ANALYTIC, this.handleQuit, this);
			this._eb.add(AnalyticsConstants.ACTION_UNDO, AnalyticsConstants.TOPIC_ANALYTIC, this.handleUndo, this);
			this._eb.add(AnalyticsConstants.ACTION_ZERO, AnalyticsConstants.TOPIC_ANALYTIC, this.handleZero, this);
			this._eb.add(AnalyticsConstants.ACTION_SCORE_500, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore500, this);
			this._eb.add(AnalyticsConstants.ACTION_SCORE_1000, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore1000, this);
			this._eb.add(AnalyticsConstants.ACTION_SCORE_1500, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore1500, this);
			this._eb.add(AnalyticsConstants.ACTION_SCORE_2000, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore2000, this);
			this._eb.add(AnalyticsConstants.ACTION_SCORE_2500, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore2500, this);
			this._eb.add(AnalyticsConstants.ACTION_SCORE_MORE_2500, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScoreMore2500, this);
			this._eb.add(AnalyticsConstants.ACTION_HELP, AnalyticsConstants.TOPIC_ANALYTIC, this.handleHelp, this);
			this._eb.add(AnalyticsConstants.ACTION_COLOR, AnalyticsConstants.TOPIC_ANALYTIC, this.handleColor, this);
			this._eb.add(AnalyticsConstants.ACTION_COLOR_1, AnalyticsConstants.TOPIC_ANALYTIC, this.handleColor1, this);
			this._eb.add(AnalyticsConstants.ACTION_COLOR_2, AnalyticsConstants.TOPIC_ANALYTIC, this.handleColor2, this);
			this._eb.add(AnalyticsConstants.ACTION_COLOR_3, AnalyticsConstants.TOPIC_ANALYTIC, this.handleColor3, this);
			this._eb.add(AnalyticsConstants.ACTION_SOUND_ON_CLICK, AnalyticsConstants.TOPIC_ANALYTIC, this.handleSoundOnClick, this);
			this._eb.add(AnalyticsConstants.ACTION_SOUND_OFF_CLICK, AnalyticsConstants.TOPIC_ANALYTIC, this.handleSoundOffClick, this);
			this._eb.add(AnalyticsConstants.ACTION_ABANDON, AnalyticsConstants.TOPIC_ANALYTIC, this.handleAbandon, this);
			this._eb.add(AnalyticsConstants.ACTION_5_ROLL, AnalyticsConstants.TOPIC_ANALYTIC, this.handle5roll, this);
			this._eb.add(AnalyticsConstants.ACTION_TOTAL_ROLLS, AnalyticsConstants.TOPIC_ANALYTIC, this.handleTotalrolls, this);
			this._eb.add(AnalyticsConstants.ACTION_QUIT_ROLLS, AnalyticsConstants.TOPIC_ANALYTIC, this.handleQuitrolls, this);
			this._eb.add(AnalyticsConstants.ACTION_TIME_WIN, AnalyticsConstants.TOPIC_ANALYTIC, this.handleTimeWin, this);
			this._eb.add(AnalyticsConstants.ACTION_TIME_QUIT, AnalyticsConstants.TOPIC_ANALYTIC, this.handleTimeQuit, this);
		}

		// ========================= Event Handlers =========================
		public handleStart():void
		{
			let eventName:string = AnalyticsConstants.ACTION_START;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);

			// var page = "freecell/start_game";
			// this._analyticsManager.logPageview(
			// 	AnalyticsConstants.ACTION_START,
			// 	{
			// 		page:page,
			// 		title:AnalyticsConstants.ACTION_START
			// 	}
			// );
		}

		public handleSubmit(data:any):void
		{
			let score:number = data.data.score;
			let eventName:string = AnalyticsConstants.ACTION_SUBMIT;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: score
				}
			);
		}

		public handleQuit(data:any):void
		{
			let score:number = data.data.score;
			let eventName:string = AnalyticsConstants.ACTION_QUIT;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: score
				}
			);
		}

		public handleUndo():void
		{
			let eventName:string = AnalyticsConstants.ACTION_UNDO;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleZero():void
		{
			let eventName:string = AnalyticsConstants.ACTION_ZERO;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleScore500(data:any):void
		{
			let score:number = data.data.score;
			let eventName:string = AnalyticsConstants.ACTION_SCORE_500;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: score
				}
			);
		}

		public handleScore1000(data:any):void
		{
			let score:number = data.data.score;
			let eventName:string = AnalyticsConstants.ACTION_SCORE_1000;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: score
				}
			);
		}

		public handleScore1500(data:any):void
		{
			let score:number = data.data.score;
			let eventName:string = AnalyticsConstants.ACTION_SCORE_1500;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: score
				}
			);
		}

		public handleScore2000(data:any):void
		{
			let score:number = data.data.score;
			let eventName:string = AnalyticsConstants.ACTION_SCORE_2000;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: score
				}
			);
		}

		public handleScore2500(data:any):void
		{
			let score:number = data.data.score;
			let eventName:string = AnalyticsConstants.ACTION_SCORE_2500;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: score
				}
			);
		}

		public handleScoreMore2500(data:any):void
		{
			let score:number = data.data.score;
			let eventName:string = AnalyticsConstants.ACTION_SCORE_MORE_2500;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: score
				}
			);
		}

		public handleHelp():void
		{
			let eventName:string = AnalyticsConstants.ACTION_HELP;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleColor():void
		{
			let eventName:string = AnalyticsConstants.ACTION_COLOR;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleColor1():void
		{
			let eventName:string = AnalyticsConstants.ACTION_COLOR_1;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleColor2():void
		{
			let eventName:string = AnalyticsConstants.ACTION_COLOR_2;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleColor3():void
		{
			let eventName:string = AnalyticsConstants.ACTION_COLOR_3;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleSoundOffClick():void
		{
			let eventName:string = AnalyticsConstants.ACTION_SOUND_OFF_CLICK;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleSoundOnClick():void
		{
			let eventName:string = AnalyticsConstants.ACTION_SOUND_ON_CLICK;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleAbandon():void
		{
			let eventName:string = AnalyticsConstants.ACTION_ABANDON;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handle5roll():void
		{
			let eventName:string = AnalyticsConstants.ACTION_5_ROLL;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: 1
				}
			);
		}

		public handleTotalrolls(data:any):void
		{
			let value:number = data.data.value;
			let eventName:string = AnalyticsConstants.ACTION_TOTAL_ROLLS;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: value
				}
			);
		}

		public handleQuitrolls(data:any):void
		{
			let value:number = data.data.value;
			let eventName:string = AnalyticsConstants.ACTION_QUIT_ROLLS;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: value
				}
			);
		}

		public handleTimeWin(data:any):void
		{
			let seconds:number = data.data.seconds;
			let eventName:string = AnalyticsConstants.ACTION_TIME_WIN;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: seconds
				}
			);
		}

		public handleTimeQuit(data:any):void
		{
			let seconds:number = data.data.seconds;
			let eventName:string = AnalyticsConstants.ACTION_TIME_QUIT;
			this._analyticsManager.logEvent(
				eventName,
				{
					category: this.gameVersion,
					action: eventName,
					label: AnalyticsConstants.FIVE_ROLL_PIXI,
					value: seconds
				}
			);
		}

		private get gameVersion():string
		{
			var version:string = "1.0.100";
			return version;
		}

		// ========================= Destruction =========================
		public destroy():void
		{
			// Remove event listeners
			this._eb.remove(AnalyticsConstants.ACTION_START, AnalyticsConstants.TOPIC_ANALYTIC, this.handleStart, this);
			this._eb.remove(AnalyticsConstants.ACTION_SUBMIT, AnalyticsConstants.TOPIC_ANALYTIC, this.handleSubmit, this);
			this._eb.remove(AnalyticsConstants.ACTION_QUIT, AnalyticsConstants.TOPIC_ANALYTIC, this.handleQuit, this);
			this._eb.remove(AnalyticsConstants.ACTION_UNDO, AnalyticsConstants.TOPIC_ANALYTIC, this.handleUndo, this);
			this._eb.remove(AnalyticsConstants.ACTION_ZERO, AnalyticsConstants.TOPIC_ANALYTIC, this.handleZero, this);
			this._eb.remove(AnalyticsConstants.ACTION_SCORE_500, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore500, this);
			this._eb.remove(AnalyticsConstants.ACTION_SCORE_1000, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore1000, this);
			this._eb.remove(AnalyticsConstants.ACTION_SCORE_1500, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore1500, this);
			this._eb.remove(AnalyticsConstants.ACTION_SCORE_2000, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore2000, this);
			this._eb.remove(AnalyticsConstants.ACTION_SCORE_2500, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScore2500, this);
			this._eb.remove(AnalyticsConstants.ACTION_SCORE_MORE_2500, AnalyticsConstants.TOPIC_ANALYTIC, this.handleScoreMore2500, this);
			this._eb.remove(AnalyticsConstants.ACTION_HELP, AnalyticsConstants.TOPIC_ANALYTIC, this.handleHelp, this);
			this._eb.remove(AnalyticsConstants.ACTION_COLOR, AnalyticsConstants.TOPIC_ANALYTIC, this.handleColor, this);
			this._eb.remove(AnalyticsConstants.ACTION_COLOR_1, AnalyticsConstants.TOPIC_ANALYTIC, this.handleColor1, this);
			this._eb.remove(AnalyticsConstants.ACTION_COLOR_2, AnalyticsConstants.TOPIC_ANALYTIC, this.handleColor2, this);
			this._eb.remove(AnalyticsConstants.ACTION_COLOR_3, AnalyticsConstants.TOPIC_ANALYTIC, this.handleColor3, this);
			this._eb.remove(AnalyticsConstants.ACTION_SOUND_ON_CLICK, AnalyticsConstants.TOPIC_ANALYTIC, this.handleSoundOnClick, this);
			this._eb.remove(AnalyticsConstants.ACTION_SOUND_OFF_CLICK, AnalyticsConstants.TOPIC_ANALYTIC, this.handleSoundOffClick, this);
			this._eb.remove(AnalyticsConstants.ACTION_ABANDON, AnalyticsConstants.TOPIC_ANALYTIC, this.handleAbandon, this);
			this._eb.remove(AnalyticsConstants.ACTION_5_ROLL, AnalyticsConstants.TOPIC_ANALYTIC, this.handle5roll, this);
			this._eb.remove(AnalyticsConstants.ACTION_TOTAL_ROLLS, AnalyticsConstants.TOPIC_ANALYTIC, this.handleTotalrolls, this);
			this._eb.remove(AnalyticsConstants.ACTION_QUIT_ROLLS, AnalyticsConstants.TOPIC_ANALYTIC, this.handleQuitrolls, this);
			this._eb.remove(AnalyticsConstants.ACTION_TIME_WIN, AnalyticsConstants.TOPIC_ANALYTIC, this.handleTimeWin, this);
			this._eb.remove(AnalyticsConstants.ACTION_TIME_QUIT, AnalyticsConstants.TOPIC_ANALYTIC, this.handleTimeQuit, this);

			// Nullify references
			this._analyticsManager = null;
			this._eb = null;
		}
	}
}



// WEBPACK FOOTER //
// src/typescript/Game/Analytics/AnalyticsHelper.ts